import React, { useState, useMemo } from 'react';
import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { removeDiacritics } from '../../../../../util/string.util';
import { OrderStatusFilter } from '../OrderStatusFilter';
import { OrderStatus, OrderUtil } from '../../../../../types/order/';

interface OrderStatusFilterContentProps {
  filter: OrderStatusFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
  color?: string;
}

const orderStatusFilter = (status: string, text: string, filter: FilterProps) => {
  const filterText = removeDiacritics(text.toLowerCase());
  if (removeDiacritics(status.toLowerCase()).includes(filterText)) return true;
  if (removeDiacritics(status.toLowerCase()).includes(filterText)) return true;
  return false;
};

export default function OrderStatusFilterContent({
  filter,
  filterProps,
  setFilterProps,
  color,
}: OrderStatusFilterContentProps) {
  const [textFilter, setTextFilter] = useState<string>('');

  const values = useMemo(() => {
    return new Set([...Object.values(OrderStatus)].filter(status => filter.search(status, textFilter)));
  }, [textFilter, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.orderStatus = selected;
    if (!filterProps.orderStatus?.size) filterProps.orderStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.orderStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>
              {t(TranslationKey.orderStatus).singular.label}
            </p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setTextFilter(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          color={color}
          selected={filterProps.orderStatus}
          values={values}
          onChange={handleChange}
          toText={id => OrderUtil.statusToString(id as OrderStatus)}
        />
      </Grid>
    </Grid>
  );
}
